export default __webpack_public_path__ + "static/banner-2ccd3161b4df4f18b14538697f7986c4.jpg";